/**
 * Default theme settings.
 *
 */

//
// Export theme
//
export default {
  version: "1.0.0",
  width: "48px",
  height: "24px",

  borderWidth: "2px",
  borderColor: "#aaa",
  leftBorderColor: "#aaa",
  rightBorderColor: "#3887b7",

  leftBackgroundColor : "#fff",
  rightBackgroundColor : "#fff",
  backgroundColorDisabled : "#eee",

  radius : "256px",
  radiusBackground : "256px",
  knobRadius : "100%",

  knobWidth : "16px",
  knobHeight : "16px",
  knobGap: "4px",

  knobColor: "#aaa",
  leftKnobColor: "#aaa",
  rightKnobColor: "#3887b7",
};